"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginStrategyEnum = void 0;
var LoginStrategyEnum;
(function (LoginStrategyEnum) {
    LoginStrategyEnum["Local"] = "local";
    LoginStrategyEnum["Google"] = "google";
    LoginStrategyEnum["Microsoft"] = "microsoft";
})(LoginStrategyEnum = exports.LoginStrategyEnum || (exports.LoginStrategyEnum = {}));
